import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer(props) {
	let date = new Date();
	let year = date.getFullYear();

	let english = {
		"footer_text": "Created by Robert Buritta"
	};

	let polish = {
		"footer_text": "Stworzone przez Roberta Buritta"
	};

	let language = '';
	if (props.language === 'english') {
		language = english;
	} else {
		language = polish;
	}

	return (
		<Container fluid className='footer'>
			<Row>
				<Col md='4' className='footer-text'>
					<h3>{language.footer_text}</h3>
				</Col>
				<Col md='4' className='footer-copyright'>
					<h3>Copyright © {year}</h3>
				</Col>
				<Col md='4' className='footer-body'>
					<ul className='footer-icons'>
						<li className='social-icons'>
							<a href='https://github.com/robertburitta' target='_blank' rel='noreferrer'>
								<i className='fab fa-github social-icon'></i>
							</a>
						</li>
						<li className='social-icons'>
							<a href='https://bitbucket.org/rezuss' target='_blank' rel='noreferrer'>
								<i className='fab fa-bitbucket social-icon'></i>
							</a>
						</li>
						<li className='social-icons'>
							<a href='https://www.linkedin.com/in/robert-buritta-313681187' target='_blank' rel='noreferrer'>
								<i className='fab fa-linkedin-in social-icon'></i>
							</a>
						</li>
					</ul>
				</Col>
			</Row>
		</Container>
	);
}

export default Footer;
